export const LIST_ID_ATTRIBUTE = 'data-list-id';
// This width value is used to determine page size for paginated experiences.
// If this value changes in `List.less`, please keep it in sync here!
export const LIST_WIDTH = 272;
